import React from 'react';
import PropTypes from 'prop-types';
import { forEach, noop, entries } from 'lodash';
import { UI_EVENTS, VIDEO_EVENTS, EngineState, } from 'playable/dist/src/constants';
export class PlayerAPIFacade extends React.Component {
    constructor(props) {
        super(props);
        this.unbindEvents = () => {
            const { eventEmitter } = this.props;
            forEach(this.listeners, (handler, event) => {
                eventEmitter.off(event, handler);
                delete this.listeners[event];
            });
        };
        this.addListener = (event, handler) => {
            const { eventEmitter } = this.props;
            const wrappedHandler = (...args) => {
                if (this._isMounted) {
                    handler(...args);
                }
            };
            this.listeners[event] = wrappedHandler;
            eventEmitter.on(event, wrappedHandler);
        };
        this.setPlaybackStatusState = ({ nextState }) => {
            this.setState({
                isVideoEnded: nextState === EngineState.ENDED,
                isVideoPaused: nextState === EngineState.PAUSED,
                isVideoPlaying: nextState === EngineState.PLAYING,
            });
            this.props.onPlaybackStateChanged(nextState);
        };
        this.showMainBlockControls = () => {
            this.setState({
                isControlsShown: true,
            });
        };
        this.hideMainBlockControls = () => {
            this.setState({
                isControlsShown: false,
            });
        };
        this.setFullScreenState = (isPlayerInFullScreen) => {
            this.setState({ isPlayerInFullScreen });
            this.props.onFullScreenChanged(Boolean(isPlayerInFullScreen));
        };
        this.hidePlayerUI = () => {
            const { mainUIBlock, cards } = this.props;
            mainUIBlock.disableShowingContent();
            mainUIBlock.hide();
            cards.hide();
        };
        this.showPlayerUI = () => {
            const { mainUIBlock, cards } = this.props;
            mainUIBlock.enableShowingContent();
            mainUIBlock.show();
            cards.show();
        };
        this.exitFullScreen = () => {
            const { fullScreenManager } = this.props;
            if (fullScreenManager.isInFullScreen) {
                fullScreenManager.exitFullScreen();
            }
        };
        this.pauseVideo = () => {
            const { engine } = this.props;
            engine.pause();
        };
        this._isMounted = false;
        this.listeners = {};
        this.state = {
            isVideoEnded: false,
            isVideoPaused: true,
            isControlsShown: false,
            isPlayerInFullScreen: false,
        };
        this.bindEvents();
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this.unbindEvents();
        this._isMounted = false;
    }
    bindEvents() {
        const { onError, onPlayAbort, onSeek, onUserSeek, onMute, onVolumeChange } = this.props;
        const uiHandlers = {
            [UI_EVENTS.MAIN_BLOCK_SHOW]: this.showMainBlockControls,
            [UI_EVENTS.MAIN_BLOCK_HIDE]: this.hideMainBlockControls,
            [UI_EVENTS.FULL_SCREEN_STATE_CHANGED]: this.setFullScreenState,
            [UI_EVENTS.PROGRESS_CHANGE]: onUserSeek,
            [UI_EVENTS.GO_BACKWARD_WITH_KEYBOARD]: onUserSeek,
            [UI_EVENTS.GO_FORWARD_WITH_KEYBOARD]: onUserSeek,
        };
        const videoHandlers = {
            [VIDEO_EVENTS.STATE_CHANGED]: this.setPlaybackStatusState,
            [VIDEO_EVENTS.ERROR]: onError,
            [VIDEO_EVENTS.PLAY_ABORTED]: onPlayAbort,
            [VIDEO_EVENTS.SEEK_IN_PROGRESS]: onSeek,
            [VIDEO_EVENTS.MUTE_CHANGED]: onMute,
            [VIDEO_EVENTS.VOLUME_CHANGED]: onVolumeChange,
        };
        entries({ ...uiHandlers, ...videoHandlers }).forEach(([eventName, handler]) => {
            this.addListener(eventName, handler);
        });
    }
    render() {
        const { children } = this.props;
        return (React.createElement("section", null, React.Children.map(children, (child) => child
            ? React.cloneElement(child, {
                ...this.state,
                pauseVideo: this.pauseVideo,
                exitFullScreen: this.exitFullScreen,
                hidePlayerUI: this.hidePlayerUI,
                showPlayerUI: this.showPlayerUI,
            })
            : child)));
    }
}
PlayerAPIFacade.dependencies = [
    'engine',
    'eventEmitter',
    'fullScreenManager',
    'mainUIBlock',
    'cards',
];
PlayerAPIFacade.propTypes = {
    eventEmitter: PropTypes.object,
    engine: PropTypes.object,
    fullScreenManager: PropTypes.object,
    cards: PropTypes.object,
    children: PropTypes.node,
    mainUIBlock: PropTypes.object,
    onFullScreenChanged: PropTypes.func,
    onError: PropTypes.func,
    onPlayAbort: PropTypes.func,
    onMute: PropTypes.func,
    onVolumeChange: PropTypes.func,
    onSeek: PropTypes.func,
    onUserSeek: PropTypes.func,
};
PlayerAPIFacade.defaultProps = {
    onSeek: noop,
    onUserSeek: noop,
    onError: noop,
    onPlayAbort: noop,
    onMute: noop,
    onVolumeChange: noop,
    onPlaybackStateChanged: noop,
};
//# sourceMappingURL=player-api-facade.js.map